import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=72c7a055&scoped=true&"
import script from "./VerifyCode.vue?vue&type=script&lang=js&"
export * from "./VerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCode.vue?vue&type=style&index=0&id=72c7a055&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7a055",
  null
  
)

export default component.exports